import React, { useState, useEffect } from "react";

const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("ca_theme") || "dark");
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme === "light" ? "light" : "");
    localStorage.setItem("ca_theme", theme);
  }, [theme]);

  const isLight = theme === "light";
  return (
    <div
      onClick={() => setTheme(t => t === "dark" ? "light" : "dark")}
      title={isLight ? "Switch to Dark" : "Switch to Light"}
      style={{
        display: "flex", alignItems: "center", gap: 6,
        cursor: "pointer", userSelect: "none",
        background: "var(--bg-elevated)",
        border: "1px solid var(--border)",
        borderRadius: 20, padding: "4px 10px",
        fontSize: 12, fontWeight: 600,
        color: "var(--text-muted)",
        transition: "all 150ms ease",
      }}
    >
      <span style={{ fontSize: 14 }}>{isLight ? "  " : ""}</span>
      <div style={{
        width: 32, height: 18, borderRadius: 9,
        background: isLight ? "var(--accent)" : "var(--bg-card)",
        border: "1px solid var(--border)",
        position: "relative", transition: "background 200ms",
        flexShrink: 0,
      }}>
        <div style={{
          position: "absolute", top: 2,
          left: isLight ? 14 : 2,
          width: 12, height: 12, borderRadius: "50%",
          background: isLight ? "#fff" : "var(--text-muted)",
          transition: "left 200ms ease",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
        }} />
      </div>
      <span style={{ fontSize: 11, letterSpacing: "0.03em" }}>
        {isLight ? "Light" : "Dark"}
      </span>
    </div>
  );
};

export default ThemeToggle;
